<template>
  <main class="ecosystem" :class="padded">
    <div class="background ecosystem__background">
      <h3 class="background__banner ecosystem__banner" :class="classes">{{ content.banner }}</h3>
      <background-vector :animated="true" class="ecosystem__vector" :images="logos" :hide-images="hideLogos"
        :scale="background.scale" :viewbox="background.viewbox"
        @vector-ready="ready = true"/>
    </div>

    <div v-if="!mobile" class="ecosystem__cta" :class="(hideLogos) ? 'ecosystem__cta--hidden' : ''">
      <router-link to="/ecosysteme/details" class="button button--border">
        <svg class="button__border"><use xlink:href="#button-border"/></svg>
        <span class="button__label">{{ content.label }}</span>
      </router-link>
    </div>

    <ul v-else class="ecosystem__list" :class="(hideLogos) ? 'ecosystem__list--hidden' : ''">
      <router-link v-for="logo in content.logos" tag="li" :to="`/ecosysteme/${logo.path}`" class="ecosystem__logo">
        <img :src="logo.image.url" :alt="logo.image.alt"/>
      </router-link>

      <li class="ecosystem__logo ecosystem__cta">
        <router-link to="/ecosysteme/details" class="button button--border">
          <svg class="button__border"><use xlink:href="#button-border"/></svg>
          <span class="button__label">{{ content.label }}</span>
        </router-link>
      </li>
    </ul>

    <transition name="entity">
      <router-view v-if="ready" :details="details"/>
      <!-- <entity-details v-if="entity.show" :entity="entity.content" @hide-details="entity.show = false"/> -->
    </transition>

    <header-nav modifier="ecosystem"/>
    <footer-nav modifier="ecosystem" :sidebars="sidebars"/>
  </main>
</template>

<script>
import metaData from '../../mixins/meta-data'
import EntityDetails from './EntityDetails'

export default {
  name: 'ecosystem-view',
  components: { EntityDetails },
  mixins: [metaData],

  beforeMount() {
    this.setLogos()
    this.setDetails([
      { path: 'details', name: this.content.title, details: this.content.details },
      ...this.content.logos
    ])
  },

  mounted() {
    document.body.scrollTop = 0
  },

  data() {
    return {
      sidebars: {
        left: { to: '/', modifier: 'contrast' },
        right: { to: '/blogue', modifier: 'fill' }
      },
      logos: [],
      details: {},
      ready: false
    }
  },

  computed: {
    mobile() { return this.$media.phone },
    content() { return this.$store.state.content.ecosystem },
    hideLogos() { return !this.ready || !!this.$route.params.entity },
    background() {
      return {
        viewbox: {
          offsetX: (this.mobile) ? 200 : null,
          offsetY: (this.mobile) ? 125 : null
        },
        scale: (this.mobile) ? 1.5 : null
      }
    },
    padded() {
      return {
        'padded': this.hideLogos
      }
    },
    classes() {
      return {
        'hidden': !this.ready
      }
    }
  },

  methods: {
    setLogos() {
      ['c', 'g', 'h', 'i'].some((key, index) => {
        let logo = this.content.logos[index]

        if (logo.image && logo.image.url) {
          this.logos.push({
            url: logo.image.url,
            path: logo.path,
            name: logo.name,
            key
          })
        }

        return index + 1 === this.content.logos.length
      })
    },
    setDetails(entities) {
      entities.forEach(({ path, name: title, details, image, url }) => {
        this.details[path] = {
          path,
          title,
          details,
          image,
          url
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '~sass/tools';

.entity {
  &-enter-active {
    transition: opacity 350ms cb(io) 250ms;
  }

  &-leave-active {
    transition: opacity 300ms cb(io);
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-enter-to,
  &-leave {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// Ecosystem.vue?0033f23c